import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import "./JsonViewer.css";
import clsx from "clsx";

import { Text, View } from ".";

type JsonViewerProps = {
  data: any;
  className?: string;
  collapsed?: number;
  maxDepth?: number;
};

const parseJson = (data: Record<string, unknown> | string) => {
  try {
    return JSON.parse(typeof data === "string" ? data : JSON.stringify(data));
  } catch {
    return data;
  }
};

export const JsonViewer = ({ data, className, collapsed = 2, maxDepth = 3 }: JsonViewerProps) => {
  const dataToShow = parseJson(data);

  return (
    <View className={clsx("json-viewer-container", className)}>
      {typeof dataToShow === "string" ? (
        <Text className="text-xs text-gray-500 whitespace-pre-wrap">{typeof data === "string" ? data.replace(/\\n/g, "\n") : data}</Text>
      ) : (
        <JsonView
          src={dataToShow}
          collapsed={collapsed}
          enableClipboard={false}
          collapseStringsAfterLength={5000}
          theme={window.document.documentElement.classList.contains("dark") ? "vscode" : "default"}
          style={{
            fontSize: "12px",
            backgroundColor: "transparent",
          }}
        />
      )}
    </View>
  );
};
